/**
 * Ba moc man hinh DUY NHAT cua web — CSS va JS dung chung bo so nay.
 *
 * CSS khong dung bien trong @media duoc, nen viet thang so:
 *   @media (max-width: 640px)  — dien thoai
 *   @media (max-width: 900px)  — tablet / sidebar thu gon
 *   @media (max-width: 1200px) — laptop hep
 * `npm run check:breakpoints -w @atino/web` bao cac moc khac.
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 900,
  lg: 1200,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

/** Media query "nho hon hoac bang" moc — dung cho matchMedia. */
export const maxWidth = (bp: Breakpoint): string => `(max-width: ${BREAKPOINTS[bp]}px)`;
